import type { WebsiteBlogPost } from '@/lib/contentService';

/** Generated by scripts/generate-blog-covers.mjs; file name is the canonical blog slug. */
const coverModules = import.meta.glob<string>('../assets/blog-covers/*.webp', {
  eager: true,
  import: 'default',
});

const coversBySlug: Record<string, string> = Object.fromEntries(
  Object.entries(coverModules).map(([file, url]) => [file.split('/').pop()!.replace(/\.webp$/, ''), url]),
);

export function getBlogCoverImage(post: Pick<WebsiteBlogPost, 'slug' | 'cover_image'>): string | null {
  return coversBySlug[post.slug] ?? post.cover_image ?? null;
}
